import AddTaskIcon from "@mui/icons-material/AddTask";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  Autocomplete,
  CircularProgress,
  FormHelperText,
  IconButton,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import {
  ATTACHMENT_URL,
  GET_PRIORITY_BY_URGENCY_IMPACT_URL,
  IMPACTS_URL,
  PRIORITIES_URL,
  REQUEST_TYPE_URL,
  SOURCE_TYPES_URL,
  TICKET_CATEGORIES_URL,
  TICKET_URL,
  URGENCIES_URL,
  USERS_SEARCH_URL,
  EMAIL_INGETION_USER_BY_EMAIL,
  EMAIL_INGETION_MARK_READ
} from "../../Constants/Constants";
import { STATUS_SEQ_ID } from "../../Constants/StatusConstants";
import AxiosInstance from "../../services/AxiosInstance";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import { useAlert } from "./../alerts//AlertContext";
import { hasRole } from "../../auth/authService";
import { ROLE_ADMIN } from "../../Constants/RolesConstants";
import { isEmpty } from "../../Constants/RolesConstants";

function TicketQueueDialog({ callQueue, emailData, componentPermissions, disabled = false, tooltipTitle }) {
  const [subject, setSubject] = useState("");
  const [urgencyId, setUrgencyId] = useState("");
  const [urgencies, setUrgencies] = useState([]);

  const [categoryId, setCategoryId] = useState("");
  const [categories, setCategories] = useState([]);

  const [impactId, setImpactId] = useState("");
  const [impacts, setImpacts] = useState([]);

  const [priorityId, setPriorityId] = useState("");
  const [priorities, setPriorities] = useState([]);

  const [sourceTypeId, setSourceTypeId] = useState("");
  const [sourceTypes, setSourceTypes] = useState([]);

  const [description, setDescription] = useState("");

  const [requestTypeId, setRequestTypeId] = useState("");
  const [requestTypes, setRequestTypes] = useState([]);

  const [error, setError] = useState(false);

  // onBehlfof user fetching
  const [onBehalfOfUsers, setOnBehalfOfUsers] = useState([]);
  const [searchUser, setSearchUser] = useState("");
  const [searchUserValue, setSearchUserValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const [formData, setFormData] = useState({
    subject: "",
    description: "",
    requestType: "",
    category: "",
    urgency: "",
    impact: "",
    sourceType: "",
    onBehalfOf: "",
  });

  const [formErrors, setFormErrors] = useState({
    subject: "",
    description: "",
    requestType: "",
    category: "",
    urgency: "",
    impact: "",
    sourceType: "",
  });

  const [ticket, setTicket] = useState({
    subject: "",
    description: "",
    requestType: {},
    urgency: {},
    impact: {},
    priority: {},
    user: {},
    status: {},
    beHalfOfUser: {},
    ticketCategory: {},
    sourceType: {},
    //attachments: {}
  });

  const [files, setFiles] = useState([]);

  const [open, setOpen] = useState(false);

  const handleFormData = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const errors = {};

    if (!formData.subject.trim()) errors.subject = "Subject is required";
    if (!formData.description.trim())
      errors.description = "Description is required";
    if (!formData.requestType) errors.requestType = "Request Type is required";
    if (!formData.category) errors.category = "Category is required";
    if (!formData.urgency) errors.urgency = "Urgency is required";
    if (!formData.impact) errors.impact = "Impact is required";
    if (!formData.sourceType) errors.sourceType = "Source Type is required";

    return errors;
  };

  function convertBackendImageToFile(data) {
        if (!data || !data.bytes) return null;

        // Handle byte[] of base64 OR base64 string
        const base64 = Array.isArray(data.bytes)
            ? new TextDecoder().decode(new Uint8Array(data.bytes))
            : data.bytes;

        const mime = data.fileType || "image/png";
        const fileName = data.fileName || `image.${mime.split("/")[1]}`;

        // Convert base64 → Blob
        const byteChars = atob(base64);
        const byteNums = new Uint8Array(byteChars.length);

        for (let i = 0; i < byteChars.length; i++) {
            byteNums[i] = byteChars.charCodeAt(i);
        }

        const blob = new Blob([byteNums], { type: mime });

        // Blob → File
        return new File([blob], fileName, { type: mime });
    }

  useEffect(() => {
    if (!emailData) return;
    setFiles([]);
    setSearchUserValue(emailData.fromUser ?? null);

    setFormData((prev) => ({
      ...prev,
      subject: emailData.subject ?? "",
      description: emailData.body ?? "",
      onBehalfOf: getUserDisplayLabel(emailData.fromUser, emailData.from),
    }));
    setSubject(emailData.subject ?? "");
    setDescription(emailData.body ?? "");
    getUserDataByEmail(emailData);

    const attachments = emailData.inboxAttachmentDTOs || [];
    const initialFiles = [];
    attachments.forEach((attachment) => {
      const fileName = attachment.fileName || attachment.name || "Unnamed File";
      const file = convertBackendImageToFile({
        bytes: attachment.fileBytes,
        fileName,
        fileType: attachment.extension,
      });
      if (file) {
        initialFiles.push(file);
      } else {
        initialFiles.push({ name: fileName, fileName, _placeholder: true });
      }
    });
    setFiles(initialFiles);
  }, [emailData]);

  const showAlert = useAlert();

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const handleClickOpen = () => {
    setOpen(true);
    initializeSysValues();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubjectChange = (event) => {
    setSubject(event.target.value);
    handleFormData(event);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
    handleFormData(event);
  };

  const handleRequestTypeChange = (event) => {
    setRequestTypeId(event.target.value);
    handleFormData(event);
  };

  const handleUrgencyChange = (event) => {
    setUrgencyId(event.target.value);
    if (
      event.target.value !== null &&
      event.target.value !== "" &&
      impactId !== null &&
      impactId !== ""
    ) {
      getPriorityByUrgencyAndImpact(event.target.value, impactId);
    }
    handleFormData(event);
  };

  const handleCategoryChange = (event) => {
    setCategoryId(event.target.value);
    handleFormData(event);
  };

  const handleImpactChange = (event) => {
    setImpactId(event.target.value);
    if (
      event.target.value !== null &&
      event.target.value !== "" &&
      urgencyId !== null &&
      urgencyId !== ""
    ) {
      getPriorityByUrgencyAndImpact(urgencyId, event.target.value);
    }
    handleFormData(event);
  };

  const handlePriorityChange = (event) => {
    setPriorityId(event.target.value);
  };

  const handleSourceTypeChange = (event) => {
    setSourceTypeId(event.target.value);
    handleFormData(event);
  };

  const getPriorityByUrgencyAndImpact = (urgencyId, impactId) => {
    AxiosInstance.get(GET_PRIORITY_BY_URGENCY_IMPACT_URL, {
      params: { urgencyId: urgencyId, impactId: impactId },
    }).then((response) => {
      console.log(response.data);
      setPriorityId(response.data.priority.id);
    });
  };

  const getUserDisplayLabel = (userData, fallbackEmail) => {
    if (!userData) {
      return fallbackEmail ?? "";
    }
    const displayName =
      userData.name || userData.fullName || userData.userName || "";
    const displayEmail =
      userData.email || userData.emailId || userData.mail || fallbackEmail || "";
    return [displayName, displayEmail].filter(Boolean).join(" - ");
  };

   const getUserDataByEmail = (selectedEmailData) => {
    if (!selectedEmailData?.from || selectedEmailData?.fromUser?.id) return;
    AxiosInstance.get(EMAIL_INGETION_USER_BY_EMAIL + encodeURIComponent(selectedEmailData.from)).then((response) => {
      console.log(response.data);
      setSearchUserValue(response.data);
      setFormData((prev) => ({
        ...prev,
        onBehalfOf: getUserDisplayLabel(response.data, selectedEmailData.from),
      }));
    });
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setFiles(selectedFiles);
  };

  const removeFile = (index) => {
    setFiles(files.filter((_, i) => i !== index));
  };

  const initializeSysValues = () => {
    AxiosInstance.get(SOURCE_TYPES_URL).then((response) =>
      setSourceTypes(response.data)
    );
    AxiosInstance.get(TICKET_CATEGORIES_URL).then((response) =>
      setCategories(response.data.data)
    );
    AxiosInstance.get(URGENCIES_URL).then((response) =>
      setUrgencies(response.data)
    );
    AxiosInstance.get(IMPACTS_URL).then((response) =>
      setImpacts(response.data)
    );
    AxiosInstance.get(PRIORITIES_URL).then((response) =>
      setPriorities(response.data.data)
    );
    AxiosInstance.get(REQUEST_TYPE_URL).then((response) =>
      setRequestTypes(response.data)
    );
  };
  const saveTicket = () => {
    const errors = validate();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
    } else {
      setError(false);

      const beHalfOfUserPayload = searchUserValue
        ? {
            id: searchUserValue.id,
            name:
              searchUserValue.name ||
              searchUserValue.fullName ||
              searchUserValue.userName ||
              "",
            email:
              searchUserValue.email ||
              searchUserValue.emailId ||
              searchUserValue.mail ||
              emailData?.from ||
              "",
          }
        : emailData?.from
          ? { email: emailData.from }
          : {};

      const ticketPayload = {
        ...ticket,
        subject: subject,
        description: description,
        requestType: { id: requestTypeId },
        urgency: { id: urgencyId },
        impact: { id: impactId },
        priority: { id: priorityId },
        user: { id: localStorage.getItem("id") },
        status: { seq: STATUS_SEQ_ID },
        beHalfOfUser: beHalfOfUserPayload,
        ticketCategory: { id: categoryId },
        sourceType: { id: sourceTypeId },
      };

      AxiosInstance.post(TICKET_URL, ticketPayload)
        .then((response) => {
          handleUpload(response.data.id);
          //alert("Ticket created successfully!");
          showAlert("Ticket created successfully!", "success");
          markAsRead();          
        })
        .catch((error) => {
          alert("Ticket creation failed!");
          console.error(error);
        });
      handleClose();
    }
  };

  const markAsRead = () => {
    if (!emailData?.messageId) return;
    AxiosInstance.get(EMAIL_INGETION_MARK_READ + encodeURIComponent(emailData.messageId)).then((response) => {
      console.log(response.data);
      callQueue();      
    });
  };

  const handleUpload = async (ticketId) => {
    if (files && files.length > 0) {
      const uploadableFiles = files.filter((f) => f instanceof File);
      uploadableFiles.forEach((file) => {
        const attachmentData = new FormData();
        attachmentData.append("file", file);
        attachmentData.append("ticketId", ticketId);
        AxiosInstance.post(ATTACHMENT_URL, attachmentData, {
          ...(AxiosInstance.defaults.headers["Content-Type"] =
            "multipart/form-data"),
        })
          .then((response) => {
            console.log("Attachment saved successfully");
          })
          .catch((error) => {
            alert("Save attachment failed!");
            console.error(error);
          });
      });
    }
  };
  return (
    <ThemeProvider>
      <React.Fragment>
        {/* <Button variant="outlined" onClick={handleClickOpen} style={{float:"right", margin:"2px"}}>
              Add Ticket
              </Button> */}
        {isEmpty(componentPermissions) ||
        componentPermissions?.["canCreate"] ? (
          <Tooltip
            title={tooltipTitle ?? "Add Ticket"}
            onClick={disabled ? undefined : handleClickOpen}
            style={{ cursor: disabled ? "default" : "pointer", margin: "2px" }}
          >
            <span>
              <IconButton disabled={disabled}>
                <AddTaskIcon color="primary" />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}

        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              saveTicket();
            },
          }}
        >
          <DialogTitle>Add Ticket</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "100%" },
                "& .MuiFormControl-root": { m: 1 },
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
                autoFocus
                fullWidth
                margin="dense"
                name="onBehalfOf"
                label="On Behalf Of"
                type="text"
                variant="outlined"
                value={formData.onBehalfOf ?? ""}
                disabled
              />
              <TextField
                fullWidth
                required
                margin="dense"
                name="subject"
                label="Subject"
                type="text"
                variant="outlined"
                value={formData.subject}
                error={!!formErrors.subject}
                helperText={formErrors.subject}
                onChange={handleSubjectChange}
              />
              <TextField
                fullWidth
                name="description"
                label="Description"
                placeholder="Description"
                multiline
                rows={4}
                required
                margin="dense"
                variant="outlined"
                value={formData.description}
                error={!!formErrors.description}
                helperText={formErrors.description}
                onChange={handleDescriptionChange}
              />

              <Grid container spacing={2} columns={16} sx={{ mt: 0.5 }}>
                <Grid size={8}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    required
                    error={Boolean(formErrors.requestType)}
                  >
                    <InputLabel id="queue-request-type-label">Request Type</InputLabel>
                    <Select
                      labelId="queue-request-type-label"
                      name="requestType"
                      value={formData.requestType}
                      onChange={handleRequestTypeChange}
                      label="Request Type"
                    >
                      {requestTypes.filter((rt) => rt?.id && rt?.name).map((rt) => (
                        <MenuItem key={rt.id} value={rt.id}>{rt.name}</MenuItem>
                      ))}
                    </Select>
                    {error && (
                      <FormHelperText>{formErrors.requestType}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid size={8}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    required
                    error={Boolean(formErrors.category)}
                  >
                    <InputLabel id="queue-category-label">Category</InputLabel>
                    <Select
                      labelId="queue-category-label"
                      name="category"
                      value={formData.category}
                      onChange={handleCategoryChange}
                      label="Category"
                    >
                      {categories.filter((cat) => cat?.id && cat?.name).map((cat) => (
                        <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
                      ))}
                    </Select>
                    {error && (
                      <FormHelperText>{formErrors.category}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={2} columns={16} sx={{ mt: 0.5 }}>
                <Grid size={8}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    required
                    error={Boolean(formErrors.urgency)}
                  >
                    <InputLabel id="queue-urgency-label">Urgency</InputLabel>
                    <Select
                      labelId="queue-urgency-label"
                      value={formData.urgency}
                      name="urgency"
                      onChange={handleUrgencyChange}
                      label="Urgency"
                    >
                      {urgencies.filter((u) => u?.id && u?.name).map((u) => (
                        <MenuItem key={u.id} value={u.id}>{u.name}</MenuItem>
                      ))}
                    </Select>
                    {error && <FormHelperText>{formErrors.urgency}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid size={8}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    required
                    error={Boolean(formErrors.impact)}
                  >
                    <InputLabel id="queue-impact-label">Impact</InputLabel>
                    <Select
                      labelId="queue-impact-label"
                      value={formData.impact}
                      name="impact"
                      onChange={handleImpactChange}
                      label="Impact"
                    >
                      {impacts.filter((imp) => imp?.id && imp?.name).map((imp) => (
                        <MenuItem key={imp.id} value={imp.id}>{imp.name}</MenuItem>
                      ))}
                    </Select>
                    {error && <FormHelperText>{formErrors.impact}</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={2} columns={16} sx={{ mt: 0.5 }}>
                <Grid size={8}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="queue-priority-label">Priority</InputLabel>
                    <Select
                      labelId="queue-priority-label"
                      value={priorityId}
                      onChange={handlePriorityChange}
                      label="Priority"
                      disabled
                    >
                      {priorities.filter((p) => p?.id && p?.name).map((p) => (
                        <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid size={8}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    required
                    error={Boolean(formErrors.sourceType)}
                  >
                    <InputLabel id="queue-source-type-label">Source Type</InputLabel>
                    <Select
                      labelId="queue-source-type-label"
                      value={formData.sourceType}
                      onChange={handleSourceTypeChange}
                      label="Source Type"
                      name="sourceType"
                    >
                      {sourceTypes.filter((src) => src?.id && src?.name).map((src) => (
                        <MenuItem key={src.id} value={src.id}>{src.name}</MenuItem>
                      ))}
                    </Select>
                    {error && (
                      <FormHelperText>{formErrors.sourceType}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>

              <Box sx={{ mt: 2, mb: 1 }}>
                <Button
                  component="label"
                  role={undefined}
                  variant="contained"
                  tabIndex={-1}
                  startIcon={<CloudUploadIcon />}
                  size="medium"
                >
                  Upload files
                  <VisuallyHiddenInput
                    type="file"
                    onChange={handleFileChange}
                    multiple
                  />
                </Button>
              </Box>

              {files.length > 0 && (
                <Box component="ul" sx={{ m: 0, pl: 2.5, py: 1 }}>
                  {files.map((file, index) => (
                    <Box
                      component="li"
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        py: 0.5,
                      }}
                    >
                      <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>
                        {file?.name ?? file?.fileName ?? "Unnamed File"}
                      </span>
                      <CloseIcon
                        sx={{ cursor: "pointer", fontSize: 20 }}
                        onClick={() => removeFile(index)}
                      />
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </ThemeProvider>
  );
}
export default TicketQueueDialog;
